<div class="tw-px-0 tw-pb-12.5 tw-pt-10 sm:tw-px-25">
  <div class="tw-bg-white">
    <ia-confirmation-banner [title]="'screens.error.label' | translate" [mode]="'error'">
      {{ 'screens.error.subtitle' | translate }}
    </ia-confirmation-banner>
  </div>

  <div
    class="tw-flex tw-items-center tw-justify-center tw-justify-items-start tw-pt-5 sm:tw-justify-start"
  >
    <button
      (click)="onClick()"
      [isProcessing]="false"
      class="tw-h-10.5 tw-font-semibold hb-group:tw-uppercase"
      iaButton
      id="btn-error-leave"
      size="large"
      type="button"
      variant="secondary"
      data-test-id="btn-error-leave"
    >
      {{ 'screens.error.button.leave' | translate }}
    </button>
  </div>
</div>
